import React, {useEffect, useState} from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import {PrimaryButton} from '../common/StyledButtons';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {addFlashMessage} from '../../actions/flash-message';
import {connect} from 'react-redux';
import * as api from '../../api';

function ResetPassword(props, context) {
    const {router} = context;
    const {addFlashMessage} = props;
    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (submitting) {
            if (validateEmail(email)) {
                emailPasswordRequest(email);
            }
            else {
                addFlashMessage('Invalid email address');
                setSubmitting(false);
            }
        }
    }, [submitting]);

    const validateEmail = (email) => {
        const emailRegEx = new RegExp(/\S+@\S+\.\S+/);
        return emailRegEx.test(email);
    };

    const emailPasswordRequest = (email) => {
        api.emailPasswordReset(email).then( (response) => {
            router.history.push('/login');
            addFlashMessage(response.message, 'success');
        }).catch(e => {
            addFlashMessage(`An error occurred: ${e.message}`);
            setSubmitting(false);
        });
    };

    return (
        <div className="authentication login">
            <Card className="center-all">
                <CardHeader
                    title={<Typography color="primary" className="authentication-title">Quizscape</Typography>}/>
                <CardContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography color="primary" variant="h6" className="modal-card-title">
                                Reset Password
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="email"
                                type="email"
                                label="Enter your email address"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                autoComplete="off"
                                value={email}
                                rules={[{required: true, message: 'Please enter a valid email address'}]}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PrimaryButton
                                disabled={submitting || email === ''}
                                onClick={() => setSubmitting(true)}>
                                Reset Password
                            </PrimaryButton>
                            <Button color="primary" onClick={() => router.history.push('/login')}>Back to Login</Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    );
}

ResetPassword.contextTypes = {
    router: PropTypes.object.isRequired
};

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default withRouter(connect(null, mapDispatchToProps)(ResetPassword));
